import React, { useState } from "react";
import BusinessSearchNDetails from "../../../../../components/common/forms/BusinessSearchNDetails";
import FormButtom from "../../../../../components/common/forms/FormButtom";
import FormPayment from "../../../../../components/common/forms/FormPayment";
import { upload_document } from "./EximCodeRenewals";
import { useForm } from "react-hook-form";
import axios from "axios";
import api, { url } from "../../../../../api/api";
import { v4 as uuidv4 } from "uuid";
import Documents from "../../../../../components/common/forms/Documents";
import FormBranch from "../../../../../components/common/forms/FormBranch";
import { toast } from "react-toastify";
import NewFormPayment from "../../../../../components/common/forms/NewFormPayment";

const OldExim = () => {
  const [cmpId, setCmpId] = useState(null);
  const { register, handleSubmit } = useForm();
  const [docsOutput, setDocsOutput] = useState([]);

  const [uploadProof, setUploadProof] = useState('')

  const handleClick = (data) => {
    // data.share_holders = shareHolders
    if (cmpId === null) {
      alert("First search company");
      return;
    }
    data.documents = docsOutput;
    data.company = cmpId;
    data.amendment_type = "exim_code_renewal";
    // console.log(data);

    const user = JSON.parse(localStorage.getItem("user"));

    
    api.post('services/company/amendments/', data)
      .then((response) => {
        toast.success("Data Registered Successfully")

        // let transactions = {
        //   // payment_mode: "e_wallet",
        //   amount: 2500,
        //   service_object_id: response.data.service_object_id,
        //   created_by: response.data.service_object_id,
        //   service_object_content_type: response.data.service_content_type_id,
        //   payment_proof : uploadProof,
        //   company : cmpId,
        //   transaction_type: "credit"
       
        // };

        
        // api
        // .post("/transactions/", transactions)
        // .then((response) => {
        //   toast.success("Data Registered 2 Successfully.");
        // })
        // .catch((error) => {
        //   toast.error("Error in Transaction");
        // });
      })
      .catch((error) => {
        toast.error("Error in Transaction")
      });
  };

  let data = [];
  upload_document.map((item, i) => {
    data.push({ id: uuidv4(), image: "", document_name: "" });
    return "";
  });

  return (
    <form>
      <BusinessSearchNDetails setCmpId={setCmpId} />

      {/* compnay name and other details close */}

      <div className="border-2 bg-pink-100 font-Laila border-primary-blue mt-3">
        <p className="text-primary-blue mt-0 text-lg font-semibold leading-10 text-center">
          ईक्जिम कोड नविकरण सम्बन्धि काम गर्दा शेवा शुल्क वापतको रकम रु.५,०००।–
          मात्र लाग्नेछ ।
        </p>
      </div>
      <div className=" border-primary-blue mt-3">
        <div className="flex font-Laila text-primary-blue mt-0 font-semibold leading-10 text-center">
          <span className=" text-primary-red mr-2">नोट :</span>
          ईक्जिम कोड नविकरण गर्दा नविकरण ढिला भएको समयको आधारमा राजश्व रकम थप
          लाग्नेछ ।
        </div>
      </div>

      {/* upload documents open */}
      <div className="text-primary-blue font-Calistoga flex text-lg underline my-4">
        2. Upload Document
        <span className="text-primary-blue font-Laila underline flex">
          (ईक्जिम कोड नविकरण गर्नको लागि आवश्यक पर्ने निम्न कागजपत्रहरु
          <p className="text-primary-red underline">Upload</p>
          गर्नुहोस ।)
        </span>
      </div>

 

      <Documents
        documents_data={upload_document}
        initialState={data}
        setDocument={setDocsOutput}
      />

      {/* upload documents close */}
      <div className="text-primary-blue font-Calistoga text-lg my-5 mb-6 underline">
              3. Working Branch
              <span className="text-primary-blue font-Laila underline mx-2 ">
                (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
              </span>
            </div>

      <FormBranch register={register} name="working_branch" />
      <FormButtom />
      
      <NewFormPayment handleSubmit={handleSubmit} handleClick={handleClick}
           setUploadProof={setUploadProof}
      />
    </form>
  );
};

export default OldExim;
